import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Ativacao } from 'src/app/model/Ativacao';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AtivacaoService {

  constructor(private http: HttpClient) { }

  findAll(): Observable<Ativacao[]> {
    return this.http.get<Ativacao[]>(`${environment.apiUrl}/view/ativacao`);
  }

  getDash(): Observable<Ativacao[]> {
    return this.http.get<Ativacao[]>(`${environment.apiUrl}/view/ativacao/dash`);
  }

  getDetails(idProduto: number): Observable<Ativacao[]> {
    return this.http.get<Ativacao[]>(`${environment.apiUrl}/view/ativacao/dash/details/${idProduto}`);
  }

  findById(id: number) {
    return this.http.get(`${environment.apiUrl}/view/ativacao/${id}`);
  }

  findByIdExample(id: number) { }

  save(ativacao: Ativacao) {
    return this.http.post(`${environment.apiUrl}/view/ativacao`, ativacao);
  }

  delete(id: number) {
    return this.http.delete(`${environment.apiUrl}/view/ativacao/${id}`);
  }

}
